/* global clubSiteAdmin */

import modernizr from 'modernizr';
import './utils.js';
import './results.jsx';

if (typeof(clubSiteAdmin.init) === 'function') {
	clubSiteAdmin.init();
}




// WEBPACK FOOTER //
// ./public/js/app/main.js